import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ToolbarComponent } from './common/components/toolbar/toolbar.component';
import { SidenavComponent } from './common/components/sidenav/sidenav.component';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MaterialModule } from './material.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from "@angular/material/form-field";
import { CdkDragDrop, CdkDrag, CdkDropList, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayContainer, FullscreenOverlayContainer } from '@angular/cdk/overlay';

import { LoginComponent } from './pages/login/login.component';
import { UserInfoComponent } from './common/components/user-info/user-info.component';
// 
import { ConfirmDialogComponent } from './common/components/confirm-dialog/confirm-dialog.component';
import { MasterFloatingMenuComponent } from './common/components/master-floating-menu/master-floating-menu.component';
// 
// 
import { SnackBarComponent } from './common/components/snackbar/snackbar.component';
// 
import { StylePaginatorDirective } from './common/components/paginator/style-paginator.directive';
import { SimplePaginatorComponent } from './common/components/paginator/simple-paginator/simple-paginator.component';
import { TokenInterceptorService } from './auth/token-interceptor.service';
import { SorterComponent } from './common/components/sorter/sorter.component';
import { LoaderComponent } from './common/components/loader/loader.component';
import { SearchFilterComponent } from './common/components/search-filter/search-filter.component';
import { FilterItemComponent } from './common/components/search-filter/filter-item/filter-item.component';

// 
import { ExtraPagesMenuComponent } from './common/components/extra-pages-menu/extra-pages-menu.component';
import { SearchFilterSaveDialogComponent } from './common/components/search-filter/dialogs/search-filter-save-dialog/search-filter-save-dialog.component';
import { SearchFilterLoadDialogComponent } from './common/components/search-filter/dialogs/search-filter-load-dialog/search-filter-load-dialog.component';
import { FilterDialogComponent } from './common/components/search-filter/dialogs/filter-dialog/filter-dialog.component';
// 
import { OrderStatusPipe } from './common/pipes/order-status.pipe';
import { ReversePipe } from './common/pipes/reverse.pipe';
import { DaysCustomPipe } from './common/pipes/days.pipe';
import { MonthsCustomPipe } from './common/pipes/month.pipe';
import { OODatePipe } from './common/pipes/date.pipe';
import { QuillModule } from 'ngx-quill';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CommonModule, DatePipe } from '@angular/common';








































import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';














import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';












































import { UnderConstructionComponent } from './pages/common/under-construction/under-construction.component';


































import { AccessDeniedComponent } from './pages/common/access-denied/access-denied.component';












import { SubMenuLayoutComponent } from './common/layouts/sub-menu-layout/sub-menu-layout.component';
import { SystemComponent } from './pages/system/system/system.component';
import { SystemMenuComponent } from './pages/system/system-menu/system-menu.component';
import { DepartmentComponent } from './pages/system/department/department.component';
import { DepartmentEditComponent } from './pages/system/department/department-edit/department-edit.component';
import { DepartmentSummaryComponent } from './pages/system/department/components/department-summary/department-summary.component';
import { JobPositionComponent } from './pages/system/job-position/job-position.component';
import { JobPositionEditComponent } from './pages/system/job-position/job-position-edit/job-position-edit.component';
import { EmployeeTypeComponent } from './pages/system/employee-type/employee-type.component';
import { EmployeeTypeEditComponent } from './pages/system/employee-type/employee-type-edit/employee-type-edit.component';
import { EmployeeJobTitleComponent } from './pages/system/employee-job-title/employee-job-title/employee-job-title.component';
import { EmployeeJobTitleEditComponent } from './pages/system/employee-job-title/employee-job-title-edit/employee-job-title-edit.component';
import { TaskComponent } from './pages/system/task/task.component';
import { TaskEditComponent } from './pages/system/task/task-edit/task-edit.component';
import { ShiftComponent } from './pages/system/shift/shift.component';
import { ShiftEditComponent } from './pages/system/shift/shift-edit/shift-edit.component';
import { LeaveTypeComponent } from './pages/system/leave-type/leave-type.component';
import { LeaveTypeEditComponent } from './pages/system/leave-type/leave-type-edit/leave-type-edit.component';
import { ReasonComponent } from './pages/system/reason/reason.component';
import { ReasonEditComponent } from './pages/system/reason/reason-edit/reason-edit.component';
import { SystemSettingsComponent } from './pages/system/settings/system-settings.component';
import { EmployeeComponent } from './pages/employee/employee.component';
import { EmployeeEditComponent } from './pages/employee/employee-edit/employee-edit.component';
import { RosterComponent } from './pages/roster/roster.component';
import { RosterListComponent } from './pages/roster/roster-list/roster-list.component';
import { ShiftDialogComponent } from './pages/roster/shift-dialog/shift-dialog.component';
import { DeleteShiftDialogComponent } from './pages/roster/shift-dialog/delete-shift-dialog.component';
import { RosterCloneDialogComponent } from './pages/roster/roster-clone-dialog/roster-clone-dialog.component';
import { EmployeeJobBreakDialogComponent } from './pages/employee/employee-job-break-dialog/employee-job-break-dialog.component';
import { ShopSelectDialogComponent } from './pages/roster/shop-select-dialog/shop-select-dialog.component';
import { SelectWeekDialogComponent } from './pages/roster/select-week-dialog/select-week-dialog.component';
import { RosterExportDialogComponent } from './pages/roster/roster-export-dialog/roster-export-dialog.component';

















import { CodeDirective } from './common/directives/code.directive';
// 
// Custom Date Format
// Custom Date Format
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD-MM-YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@NgModule({
  declarations: [
    AppComponent,
    ToolbarComponent,
    SidenavComponent,
    LoginComponent,
    UserInfoComponent,
    ConfirmDialogComponent,
    SnackBarComponent,
    StylePaginatorDirective,
    SimplePaginatorComponent,
    SorterComponent,
    SearchFilterComponent,
    FilterItemComponent,
    LoaderComponent,
    ExtraPagesMenuComponent,
    MasterFloatingMenuComponent,
    SearchFilterLoadDialogComponent,
    SearchFilterSaveDialogComponent,
    FilterDialogComponent,
    OrderStatusPipe,
    ReversePipe,
    DaysCustomPipe,
    MonthsCustomPipe,
    OODatePipe,
    // UtilComponent,
    UnderConstructionComponent,



    AccessDeniedComponent,


    SubMenuLayoutComponent,
    SystemComponent,
    SystemMenuComponent,
    DepartmentComponent,
    DepartmentEditComponent,
    DepartmentSummaryComponent,
    JobPositionComponent,
    JobPositionEditComponent,
    EmployeeTypeComponent,
    EmployeeTypeEditComponent,
    EmployeeJobTitleComponent,
    EmployeeJobTitleEditComponent,
    TaskComponent,
    TaskEditComponent,
    ShiftComponent,
    ShiftEditComponent,
    LeaveTypeComponent,
    LeaveTypeEditComponent,
    ReasonComponent,
    ReasonEditComponent,
    SystemSettingsComponent,
    EmployeeComponent,
    EmployeeEditComponent,
    RosterComponent,
    RosterListComponent,
    ShiftDialogComponent,
    DeleteShiftDialogComponent,
    RosterCloneDialogComponent,
    EmployeeJobBreakDialogComponent,
    ShopSelectDialogComponent,
    SelectWeekDialogComponent,
    RosterExportDialogComponent,
    CodeDirective,
  ],
  bootstrap: [AppComponent], 
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    MatAutocompleteModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    ReactiveFormsModule,
    MaterialModule,
    FormsModule,
    MatFormFieldModule,
    MatMomentDateModule, // Moment adapter for MatDatepicker
    MatInputModule,
    CdkDropList,
    CdkDrag,
    DragDropModule,
    QuillModule.forRoot({
      modules: {
        resize: {
          showSize: false,
          toolbar: {
            sizeTools: false,
            alingTools: true
          },
        },
      },
      theme: 'snow'
    }),

  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_DATE_FORMATS
    },
    {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: { useUtc: true } // optional, if you want UTC handling
    },
    {
      provide: OverlayContainer,
      useClass: FullscreenOverlayContainer
    },
    provideHttpClient(withInterceptorsFromDi()),
    DatePipe,
    provideAnimationsAsync()
  ]
})
export class AppModule { }